const offerTriggers = () => {
    const allDataOffer = document.querySelectorAll("[data-offer]");
    allDataOffer.forEach((offer) => {
      const offerV = offer.dataset.offer;
      const allDataOfferValue = offer.querySelectorAll("[data-offer-value]");

      allDataOfferValue.forEach((offerValue) => {
        const offerValueV = offerValue.dataset.offerValue;
        if (offerValueV != offerV) {
            if(!offerValue.classList.contains("hidden-offer")){
                offerValue.classList.add("hidden-offer");
            }
        }
      });
    });
}

const intervalCustom = setInterval(() => {
    if (document.readyState === "complete") {
    offerTriggers();
    clearInterval(intervalCustom);
  }
}, 10);


const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === 'class'
    ) {
    offerTriggers();
    }
  });
});

document.querySelectorAll('.image-offer-wrapper').forEach(el => {
  observer.observe(el, {
    attributes: true,
    attributeFilter: ['class']
  });
});

document.querySelectorAll('.collection-list-items-wrapper').forEach(el => {
  observer.observe(el, {
    attributes: true,
    attributeFilter: ['class']
  });
});